import { ConsignorGroup } from "@prisma/client";
import { createContext } from "react";

interface ConsignorGroupContextType {
    consignorGroups: ConsignorGroup[] | undefined;
}

const ConsignorGroupContext = createContext<ConsignorGroupContextType>({
    consignorGroups: undefined
});

export default ConsignorGroupContext;
